import { SnowflakeTableDataset } from './snowflake.dataset';
import { Metamodel } from '../base/model';
import { SnowflakeV2LinkedService } from '../linkedservice/snowflake-v2.linkedservice';
import { IAttribute, IModel } from '../base/annotation';
import { ModelConstants } from '../model-constants';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';
import { format, getConnectorV2Name } from '../../shared/utils/string.util';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';

@Metamodel.model({
    name: ModelConstants.snowflakeV2Dataset,
    display: [
        format(stringResources.ModelName_DatasetTemplate, getConnectorV2Name(stringResources.Snowflake_DisplayText, isTridentInIframe())),
        format(stringResources.ModelName_DatasetsTemplate, getConnectorV2Name(stringResources.Snowflake_DisplayText, isTridentInIframe()))
    ],
    constraints: {
        linkedService: {
            model: SnowflakeV2LinkedService.MODEL // Linked service redefined
        }
    }
})
export class SnowflakeV2TableDataset extends SnowflakeTableDataset {
    public static readonly MODEL: IModel;
    public static readonly VERSION: IAttribute;

    @Metamodel.attribute({
        display: stringResources.Type
    })
    public tableType?: 'Dynamic';

    @Metamodel.attribute({
        display: stringResources.VersionLabel,
        templatable: true,
        association: 'VERSION'
    })
    public version?: string = isTridentInIframe() ? '1.1' : undefined;
}
